module.exports = __webpack_public_path__ + "media/images/video/stretchlab-go-logo-0fda337d09fb262af187dddce13283a1.png";